import { render, staticRenderFns } from "./BackgroundConfig.v2.vue?vue&type=template&id=2cbbf493&scoped=true&"
import script from "./BackgroundConfig.v2.vue?vue&type=script&lang=js&"
export * from "./BackgroundConfig.v2.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundConfig.v2.vue?vue&type=style&index=0&id=2cbbf493&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbbf493",
  null
  
)

export default component.exports